import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NoiseAwareIcon(props: IconProps) {
    return <Icon {...props} iconKey={"noise_aware"}/>
}
